// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__384ee","info":"UpdateTermsInfo_info__2heVo"};